module.exports = __webpack_public_path__ + "static/media/1019057.eeffebd1.jpg";